module.exports = __webpack_public_path__ + "f320f61148891c44fe09ad62fe5670b8.png";